import React, { useState, useEffect } from "react";
import {Box, Paper, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Button, Stack, IconButton, } from '@mui/material';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import PageLoader from "../../../components/Loader/PageLoader"
import DeleteIcon from '@mui/icons-material/Delete';
import HeaderName from "../../../components/Custom/HeaderName";
import { EditIcon } from "../../../components/Icons";
import Swal from "sweetalert2";
import { deleteBranchDetails, getBranchList } from "../../../redux/Thunk/branchThunk";
import ThemeColor from "../../../theme/ThemeColor";

const BranchList =() =>{
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const role = localStorage.getItem('role');
  const [selectedRows, setSelectedRows] = useState([]);
  const [search,setSearch] = useState('');
  const [branchList, setBranchList] = useState([])
  // pagination
  const [page, setPage] = useState({
    page:0,
    pageSize:10
  })

  useEffect(()=>{
    fetchBranch()
  },[page])

  // get all Branch details
  const fetchBranch = async () => {
    setLoader(true)
    dispatch(getBranchList({page: page.page + 1, limit: page.pageSize})).then((res) => {
      setBranchList(res?.payload?.data)
      setTotalCount(res?.payload?.total)
      setLoader(false)
    })
  };

  const handleRowSelection = (selection) => {
    if (selection?.length === 0) {
      // If no rows selected, clear the selected rows
      setSelectedRows([]);
    } else {
      // Map the selected IDs to their corresponding rows
      // const selectedRows = selection?.map(selectedId =>
      //   facilityList.find(row => row?._id === selectedId)
      // );
      setSelectedRows(selectedRows);
    }
  };

  // Edit Branch details
  const handleClickEditBranch =(details) =>{
    navigate('/dashboard/branchList/newbranch', {state:{editDetails:details}})
  }

  // Deleted Branch details
  const handleClickDeleteBranch =(row) =>{
      Swal.fire({ 
        title: `Are you sure you want to delete the selected Branch?`,
        showCancelButton: true,
        confirmButtonText: 'Delete',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: () => {
          return dispatch(deleteBranchDetails(row?.officeBranchId)).then((res)=>{
            if (res?.payload?.success === true && res?.payload?.warning === true) {
              Swal.fire('Warning!', res?.payload?.message, 'warning');
              fetchBranch()
              setSelectedRows([])
            }else if(res?.payload?.success === true){
              Swal.fire('Deleted!', res?.payload?.message, 'delete');
              fetchBranch()
              setSelectedRows([])
            }else{
              Swal.fire('Error!', res?.payload?.message, 'error');
            }
          });
        },
      });
  }

  const columns = [
    {
      flex: 0.1,
      minWidth: 60,
      field: 'Sr.No',
      align:'center',
      headerName: 'Sr. No',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', padding:1, alignItems: 'center' }}>
            <Typography noWrap variant='body2' >
              {page?.page * page?.pageSize + params.api.getAllRowIds().indexOf(params.id)+1}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.35,
      minWidth: 120,
      field: 'BranchId',
      headerName: 'Id',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'left' }}>
            <Typography noWrap variant='body2' >
              {row?.officeBranchId}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.4,
      minWidth: 150,
      field: 'Office Name',
      headerName: 'Office Name',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.officeadmins[0]?.OfficeName || '--'}
            </Typography>
          </Box>
        )
      }
    }, 
    {
      flex: 0.4,
      minWidth: 180,
      field: 'Branch Name',
      headerName: 'Branch Name',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.branchName || '--'}
            </Typography>
          </Box>
        )
      }
    }, 
    {
      flex: 0.5,
      minWidth: 200,
      field: 'Manager Name',
      align:'center',
      headerName: 'Manager Name',
      renderCell: params => {
        const { row } = params
  
        return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.branchManagerName || '--'}
            </Typography>
          </Box>
        </>
        )
      }
    },
    {
      flex: 0.5,
      minWidth: 200,
      field: 'Email',
      align:'center',
      headerName: 'Email',
      renderCell: params => {
        const { row } = params
  
        return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.email || '--'}
            </Typography>
          </Box>
        </>
        )
      }
    },
    {
      flex: 0.35,
      minWidth: 120,
      field: 'Mobile Number',
      align:'center',
      headerName: 'Mobile Number',
      renderCell: params => {
      const { row } = params
        return (<>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
            {row?.mobile || '--'}
          </Typography>
        </Box>
        </>
        )
      }
    },
    {
      flex: 0.25,
      minWidth: 100,
      field: 'Status',
      align:'center',
      headerName: 'Status',
      renderCell: params => {
        const { row } = params
  
        return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{color:row?.status === 'Inactive' ? ThemeColor.palette.InactiveText : ThemeColor.palette.ActiveText, maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.status || '--'}
            </Typography>
          </Box>
        </>
        )
      }
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Action',
      headerName: 'Action',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2'>
                <IconButton id='edit' onClick={() => handleClickEditBranch(row)}><EditIcon w={18} h={18} /></IconButton>
                <IconButton id='delete' onClick={()=> handleClickDeleteBranch(row)}><DeleteIcon fontSize="medium" style={{color:'#04AB44'}}/></IconButton>
              </Typography>
            </Box>
          </Box>
        )
      }
    },    
  ]

    return(
        <>
          <div style={{display:'flex', flexDirection:'column', flexGrow: 1}}>
            { loader ? <PageLoader /> : 
              <Grid container style={{padding:'0px 10px', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>   
                <Grid size={{ xs: 12, sm: 12, md: 12, lg:11}}>
                  <HeaderName headerName={'Branch List'} newForm = {true} createNewForm={()=> navigate('/dashboard/branchlist/newbranch')} onClickBackButton={()=> navigate("/dashboard")} />
                  <div className="custom-data-grid-container_table">
                    <DataGrid
                      sx={{
                        borderRadius: "31px",
                        overflow: "auto",
                      }}
                      style={{ width: '100%' }}
                      pagination
                      // checkboxSelection
                      rows={branchList}
                      rowHeight={55}
                      rowCount={totalCount}
                      getRowId={param=> param._id}
                      columns={columns}
                      paginationModel={page}
                      sortingMode='server'
                      paginationMode='server'
                      pageSizeOptions={[10, 50, 100]}
                      onPaginationModelChange={(newPage)=>setPage(newPage)}
                      className="custom-data-grid"
                      selectionModel={selectedRows ? [selectedRows] : []}
                      onRowSelectionModelChange={handleRowSelection}
                      initialState={{
                        totalCount,
                        pagination: { paginationModel: {page:1, pageSize: 10}},
                      }}
                      disableRowSelectionOnClick
                      disableColumnMenu
                      disableColumnFilter
                      disableColumnSorting
                    />
                  </div>
                </Grid>
              </Grid>
            }
          </div>
        </>
    )
}

export default BranchList